const certs = [
  {
    brand: 'Briggs & Stratton',
    level: 'Master Certified',
    icon: 'ri-star-fill',
    detail:
      'The highest technician certification level — covering comprehensive small engine diagnosis and repair.',
  },
  {
    brand: 'Stihl',
    level: 'Silver Level Certified',
    icon: 'ri-award-fill',
    detail:
      'Professional certification for outdoor power equipment service and maintenance.',
  },
  {
    brand: 'Kohler',
    level: 'Certified Technician',
    icon: 'ri-shield-fill',
    detail:
      'Trained and certified for Kohler engine systems, ensuring accurate diagnosis and quality repair.',
  },
  {
    brand: 'Kawasaki',
    level: 'Certified Technician',
    icon: 'ri-verified-badge-fill',
    detail:
      'Certified to service and repair Kawasaki-powered outdoor equipment.',
  },
];

export default function CertificationsSection() {
  return (
    <section className="bg-orange-600 py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-white/70 text-xs font-bold uppercase tracking-widest mb-3">
            Our Credentials
          </p>
          <h2 className="font-display text-4xl lg:text-5xl font-bold uppercase tracking-tight text-white">
            Certified Across Top Brands
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {certs.map((cert) => (
            <div
              key={cert.brand}
              className="bg-white/10 border border-white/20 rounded-xl p-6 hover:bg-white/20 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl mb-4">
                <i className={`${cert.icon} text-white text-lg`} />
              </div>
              <div className="text-orange-100 text-xs font-semibold uppercase tracking-wider mb-1">
                {cert.level}
              </div>
              <div className="font-display text-xl font-bold text-white uppercase tracking-tight mb-2">
                {cert.brand}
              </div>
              <p className="text-white/70 text-xs leading-relaxed">
                {cert.detail}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
